import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../reducers';
import ResourceCreationPanel from '../ResourceCreationPanel';
import { renameAsset, closePanel, setName } from '../../containers/AssetRenamePanel/actions';

export interface AssetRenamePanelProps {
	isOpen: boolean;
	name: string;
	assetId: number;
	error: null | string;
	dispatch: Dispatch<StoreState>;
}

const AssetRenamePanel = ({ isOpen, name, assetId, error, dispatch }: AssetRenamePanelProps) => {
	const fieldsConfig = {
		name: {
			value: name,
		},
	};

	return (
		<ResourceCreationPanel
			isOpen={isOpen}
			icon="iconset_doc_default"
			fields={fieldsConfig}
			errors={{ name: error }}
			onFieldChange={(name, value) => dispatch(setName(value))}
			onConfirm={({ name }) => dispatch(renameAsset(assetId, name.value))}
			onCancel={() => dispatch(closePanel())}
		/>
	);
};

export default AssetRenamePanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AssetRenamePanel/index.tsx